
import { Component, OnInit } from '@angular/core';
import { NbIconLibraries } from '@nebular/theme';
import { AnalyticsService } from './@core/utils/analytics.service';
import { SeoService } from './@core/utils/seo.service';
import { CONST } from './providers/const';

@Component({
  selector: 'ngx-app',
  template: '<router-outlet></router-outlet>',
})
export class AppComponent implements OnInit {

  constructor(private analytics: AnalyticsService, private seoService: SeoService, private iconLibraries: NbIconLibraries) {
    iconLibraries.registerFontPack('fa', { packClass: 'fa', iconClassPrefix: 'fa' });
  }

  ngOnInit(): void {
    this.analytics.trackPageViews();
    this.seoService.trackCanonicalChanges();
    if (!localStorage.getItem(CONST.LOCALSTORAGE.language)) {
      localStorage.setItem(CONST.LOCALSTORAGE.language, "en-US")
    }
  }
}
